export const RECORDER_MAX_GRID_SIZE = 8;
export const RECORDER_MAX_GRID_SIZE_WITH_SCREENSCHARE_ENABLED = 8;

export const meetingModes = {
  SIGNALLING_ONLY: "SIGNALLING_ONLY",
  SEND_AND_RECV: "SEND_AND_RECV",
};
